import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/scanToOrder/qrCode/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/scanToOrder/qrCode',
    meta: {
      title: '我的二维码'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/scanToOrder/downLoad/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/scanToOrder/downLoad',
    meta: {
      title: '下载APP'
    }
  }
]
